import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'reactstrap';

import EventCategoryCard from './Card/EventCategoryCard';
import Amplify, { Auth } from 'aws-amplify';
import config from '../aws-exports'
import { UserContext } from '../components/UserContext'
// import { ScoreContext } from '../components/ScoreContext'
import Lottie from 'react-lottie';
import batchImg from '../assets/images/events-banner.png';
import { default as animationData } from '../assets/loader.json';
import {
  withAuthenticator, AmplifySignOut, ForgotPassword
} from "aws-amplify-react";
import { cx } from '@emotion/css';
import * as styles from './events.style.js';

Amplify.configure(config)
function EventCatScreen(props) {
  const [events_category, set_events_category] = useState([]);
  const [userdetails, set_userdetails] = useState({});
  const { user, setUser } = useContext(UserContext);
  const [loadedcategories, set_loadedcategories] = useState(false);

  //  const {score,setScore} = useContext(ScoreContext);

  ////console.log("Calling EventCatScreen.....")

  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    ////console.log("useEffect called in EventCatScreen")
    getToken();
    document.title = 'Event Categories';

  }, []);


  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();

        if (user.username.includes("Google_")) {


          getuserDetails(user.attributes['email'], jwt)
          getEventsfromDB(user.attributes['email'], jwt)





        }
        else {


          getuserDetails(user.username, jwt)
          ////console.log("Called getuserDetails")
          getEventsfromDB(user.username, jwt)



        }




      });




    } catch (error) {
      // console.log(error)
      Auth.signOut()
    }
  };


  // const getToken = async () => {

  //   Auth.currentSession().then(res => {
  //     ////console.log("Auth.currentSession()")
  //     let accessToken = res.getAccessToken()
  //     ////console.log("accessToken called ")
  //     let jwt = accessToken.getJwtToken()

  //     if (Auth.user == null) {
  //       Auth.signOut();

  //     }

  //     getuserDetails(Auth.user.username, jwt)
  //     ////console.log("Called getuserDetails")
  //     getEventsfromDB(Auth.user.username, jwt)
  //     ////console.log("Called getEventsfromDB")    


  //   })
  // };

  const getEventsfromDB = async (username, jwt) => {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },

      body: JSON.stringify({ 'username': username, 'eventtype': 'Event' })

    };
    const response = await fetch(`https://api.quizwizard.net/quiz/eventcounts`, requestOptions)
    const data = await response.json();
    //////console.log('Output from the API is ')  
    ////console.log(data)
    set_events_category(data)
    set_loadedcategories(true)

    ////console.log("getEventsfromDB done")
    ////console.log(events_category) 
  };
  // const CreatorUpdateUser = async (username, jwt) => {

  //   const requestOptions = {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json', 'Authorization': jwt },
  //     body: JSON.stringify({ 'username': username, 'score': 1000, 'appname': 'QuizWhiz', 'score': 1000, 'reloadedpoints': 1000, 'canbeprivate': true, 'grade': 5, 'timezone': 'UTC-5', 'birthdate': '2000-01-01', 'parent': false, 'parentname': ' ', 'parentnamerequestedname': '', 'customizequestions': false, 'parentnamerequested': false, 'profilepic': 'defaultavatar', "premiumuser": 0, "friendslist": [], "friendsrequestlist": [], "sendrequestlist": [], "friendnamerequested": false, "rewardslist": [], "crown": "", "availableavatars": ["boy1", "girl1", "boy2", "girl2", "boy3", "girl3", "girl4", "girl5", "girl6", "girl7"], "nextbooster": 10, "nextunlockkey": 5, "unlockkeys": 0, "boosters": 0, 'batchlist': [], gold: 0 })

  //   };
  //   const response = await fetch(`https://api.quizwizard.net/quiz/createorupdateuser`, requestOptions)
  //   const data = await response.json();
  // };
  const getuserDetails = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },
      body: JSON.stringify({ 'username': username })


    };
    const response = await fetch(`https://api.quizwizard.net/quiz/getuser`, requestOptions)
    const data = await response.json();
    //////console.log('Output from the Get User API is ')  
    set_userdetails(data)
    setUser(data)
    ////console.log('getuserDetails done')  
    //  setScore(100)

  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  let event_category_Cards = events_category.map(eventcategory => {
    return (
      <div key={eventcategory.id} className="col-md-4">
        <Col className="py-2 border rounded" key={eventcategory.id} >
          <EventCategoryCard imgsrc={"../assets/" + encodeURIComponent(eventcategory.category) + ".png"} title="Algebra" key={eventcategory.id} eventcategory={eventcategory} target="events" />
          {/* <Event_Category_Card key={eventcategory.id}  eventcategory={eventcategory} /> */}
        </Col>
      </div>

    )
  })
  return (
    <div>
      {loadedcategories ?
        <div>
          <div className={cx(styles.batchBanner)}>
            <img src={batchImg} alt="" />
          </div>
          <div className={cx(styles.batchTitle)}>Public Quiz Events</div>
          <div className={cx(styles.cardEventsFluid)}>
            {event_category_Cards.length > 0 ? (
              <Row>{event_category_Cards}</Row>
            ) : (
              <p className={styles.subTitle}>No Events</p>
            )}

          </div>
        </div> :
        <div className="welcomecenter">
          <Lottie options={defaultOptions} height={400} width={400} />
        </div>
      }
    </div >
  )
}
export default EventCatScreen;
